import {
  InlineBannerData,
  InlineCampaign,
  InlineIssue,
  InlinePlatform,
  InlineSearch,
} from "./types";
import { resolveInlineUrl } from "./inline-url";

export function selectInlineCampaign(
  campaigns: readonly InlineCampaign[],
  search: InlineSearch,
  platform: InlinePlatform,
): { data: InlineBannerData | null; issues: InlineIssue[] } {
  const issues: InlineIssue[] = [];
  const origin = search.originAirport.trim().toUpperCase();
  const destination = search.destinationAirport.trim().toUpperCase();
  // Do not select a global campaign while the search is still being initialized.
  if (!/^[A-Z]{3}$/.test(origin) || !/^[A-Z]{3}$/.test(destination))
    return { data: null, issues };
  for (const campaign of campaigns) {
    if (
      !campaign.active ||
      (campaign.platforms.length > 0 &&
        !campaign.platforms.includes(platform)) ||
      (!campaign.origins.includes("ALL") &&
        !campaign.origins.includes(origin)) ||
      (!campaign.destinations.includes("ALL") &&
        !campaign.destinations.includes(destination))
    )
      continue;
    try {
      const url = resolveInlineUrl(
        campaign.parameters.url,
        search,
        campaign.dateFormat,
      );
      return { data: { ...campaign.parameters, url }, issues };
    } catch (error) {
      issues.push({
        index: campaign.index,
        error:
          error instanceof Error ? error : new Error("URL do inline inválida"),
      });
    }
  }
  return { data: null, issues };
}
